// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__excsg","gemsLogo":"Footer_gemsLogo__cAn+X","honorsLogo":"Footer_honorsLogo__jNWwc"};